import React, { useState, useRef } from 'react';
import Link from './Link';
import { GatsbyImage } from 'gatsby-plugin-image';
import LinkList from './LinkList';
import { generateSource } from '../helpers/video';
import InlineSvg from './InlineSvg';
import Youtube from 'react-youtube';

const ListingBlockReversible = (props) => {
  const {
    has_image,
    rtl,
    title,
    excerpt,
    img_fluid,
    gatsby_image_data,
    image_alt,
    link_type,
    button_link,
    button_text,
    text_links,
    type,
    status,
    has_video,
    content_type,
    youtube_id,
    thumbnail,
    has_thumbnail,
    alt_heading
  } = props;

  const source = 'youtube';

  const [videoUrl] = useState(generateSource(source, youtube_id));
  const [showThumbnail, setShowThumbnail] = useState(true);
  const youtubePlayer = useRef(null);

  const handleThumbnailInteraction = () => {
    // const autoplayString = '&autoplay=1';
    // if (!videoUrl.includes(autoplayString)) {
    //   setVideoUrl(videoUrl + autoplayString);
    // }
    setShowThumbnail(false);
    youtubePlayer.current && youtubePlayer.current.playVideo();
  };

  const onPlayerReady = (event) => {
    youtubePlayer.current = event.target;
  };

  // TODO: move this elsewhere?
  const videoThumbnail = has_thumbnail ? (
    // TODO: add click handler to this to hide?
    <div
      className="listing-block-reversible__video-thumbnail-wrapper"
      onClick={() => handleThumbnailInteraction()}
      onKeyDown={() => handleThumbnailInteraction()}
      tabIndex={0}
      role="button"
    >
      <GatsbyImage
        image={thumbnail.localFile.childImageSharp.gatsbyImageData}
        className="listing-block-reversible__video-thumbnail"
        alt={thumbnail.alt_text || ''}
      />
      <div className="listing-block-reversible__video-thumbnail-overlay" />
      <InlineSvg
        className="listing-block-reversible__video-thumbnail-play"
        name="play-white"
      />
    </div>
  ) : null;

  const is_video = content_type && content_type === 'video' && has_video;

  return (
    <>
      {/*to avoid overly complicated cases create one output for has_image and one for without*/}
      {has_image || has_video ? (
        <>
          <div
            className={`listing-block-reversible__media ${
              rtl ? 'listing-block-reversible__media--rtl' : ''
            } ${is_video ? 'listing-block-reversible__media--video' : ''}`}
          >
            {is_video ? (
              <>
                {showThumbnail && videoThumbnail}
                {source === 'youtube' ? (
                  <Youtube
                    className="listing-block-reversible__youtube"
                    videoId={youtube_id}
                    onReady={onPlayerReady}
                    opts={{
                      controls: 1,
                      width: '100%',
                      height: '100%',
                    }}
                  />
                ) : (
                  <iframe title={title} className="listing-block-reversible__iframe" src={videoUrl} showinfo="0" controls="0" autohide="1" allow="autoplay; encrypted-media" frameBorder="0" /> /* eslint-disable-line */ 
                )}
              </>
            ) : img_fluid ? (
              <GatsbyImage image={img_fluid} alt={image_alt || ''} />
            ) : gatsby_image_data ? (
              <GatsbyImage
                image={gatsby_image_data}
                alt={image_alt || ''}
                aspectRatio={16 / 9}
              />
            ) : null}
          </div>
          <div
            className={`listing-block-reversible__content ${
              rtl ? 'listing-block-reversible__content--rtl' : ''
            }`}
          >
            {title && !alt_heading && (
              <h2
                className="listing-block-reversible__title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {title && alt_heading && (
              <h3
                className="listing-block-reversible__alt-heading"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {type && status && (
              <div className="listing-block-reversible__taxonomy">
                <span
                  className="listing-block-reversible__taxonomy-type"
                  dangerouslySetInnerHTML={{ __html: type }}
                />
                <span
                  className="listing-block-reversible__taxonomy-status"
                  dangerouslySetInnerHTML={{ __html: status }}
                />
              </div>
            )}
            {excerpt && (
              <div
                className="listing-block-reversible__excerpt body-two"
                dangerouslySetInnerHTML={{ __html: excerpt }}
              />
            )}
            {button_link && button_text && (
              <Link
                target={link_type === 'external' ? '_blank' : ''}
                to={button_link}
                className="button button--outline listing-block-reversible__button"
              >
                {button_text}
              </Link>
            )}
            {text_links && text_links.length ? (
              <LinkList links={text_links} />
            ) : null}
          </div>
        </>
      ) : (
        <>
          <div className="image-and-content-rl__title">{title && title}</div>
          {type && status && (
            <div className="listing-block__status">
              {type}
              {status}
            </div>
          )}
          {excerpt && <div dangerouslySetInnerHTML={{ __html: excerpt }} />}
          {button_link && button_text && (
            <Link
              to={button_link}
              target={link_type === 'external' ? '_blank' : ''}
              className="button button--outline listing-block-reversible__button"
            >
              {button_text}
            </Link>
          )}
          {text_links && text_links.length ? (
            <LinkList links={text_links} />
          ) : null}
        </>
      )}
    </>
  );
};

export default ListingBlockReversible;
